import {
  getAuditPlannerConfigurationKey, getModulePermissions, getSubsourcesAuditsConfigByRoles,
  getSubsourcesAuditsConfigByTeams, updateAuditPlannerConfigKey,
} from 'frontend/communications/apiClient'

const stateObj = {
  modulePermissions: [],
}

const getters = {
  getModulePermissions: (state) => (includeDisabled = false) => {
    return includeDisabled ? state.modulePermissions : state.modulePermissions.filter(perm => perm.active)
  },
  getModulePermissionsByType: (state, moduleGetters) => (type, include_children = false, includeDisabled = false) => {
    return moduleGetters.getModulePermissions(includeDisabled)
      .filter(perm => (!perm.parent || include_children) && perm.module_type === type)
  },
  getModulePermissionsByParent: (state, moduleGetters) => (parent, includeDisabled = false) => {
    return moduleGetters.getModulePermissions(includeDisabled).filter(perm => perm.parent === parent)
  },
}

const mutations = {
  setModulePermissions (state, permissions) {
    state.modulePermissions = permissions
  },
}

const actions = {
  async fetchModulePermissions ({commit}) {
    const modulePermissions = await getModulePermissions()
    commit('setModulePermissions', modulePermissions)
    return modulePermissions
  },
  async fetchSubsourcesAuditsConfigByRoles (_, payload) {
    return getSubsourcesAuditsConfigByRoles(payload)
  },
  async fetchSubsourcesAuditsConfigByTeams (_, payload) {
    return getSubsourcesAuditsConfigByTeams(payload)
  },
  async fetchAuditPlannerConfigurationKey () {
    return getAuditPlannerConfigurationKey()
  },
  async updateAuditPlannerConfigurationKey (_, payload) {
    return updateAuditPlannerConfigKey(payload)
  },
}

export default {
  state: stateObj,
  getters,
  mutations,
  actions,
}
